import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1000px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">移动观影</h2>
            <p className="text-sm text-foreground-500 mb-2">{appData.subtitle}</p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6">
              {appData.description}
            </p>
            <div className="grid grid-cols-2 gap-3 max-w-[400px] lg:max-w-none mx-auto lg:mx-0">
              {appData.features.map((feat) => (
                <div
                  key={feat}
                  className="flex items-center gap-2 px-4 py-3 rounded-lg bg-background-50 border border-background-200/60"
                >
                  <i className="ri-check-line text-accent-500 text-sm flex-shrink-0"></i>
                  <span className="text-xs md:text-sm text-foreground-700 whitespace-nowrap">{feat}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-[200px] md:w-[240px] rounded-2xl bg-background-950 p-3 shadow-lg">
              <div className="rounded-xl overflow-hidden bg-background-900 p-3">
                <div className="rounded-lg bg-background-800 p-3">
                  <div className="w-full h-8 rounded bg-accent-500/20 flex items-center justify-center mb-3">
                    <span className="text-xs text-accent-300 font-medium">天堂影院</span>
                  </div>
                  <div className="space-y-2">
                    <div className="h-2 rounded bg-background-600 w-3/4"></div>
                    <div className="h-2 rounded bg-background-600 w-1/2"></div>
                    <div className="h-2 rounded bg-background-600 w-2/3"></div>
                  </div>
                  <div className="mt-3 space-y-2">
                    {[1, 2, 3].map((i) => (
                      <div key={i} className="h-10 rounded bg-background-700 flex items-center px-3 gap-2">
                        <div className="w-6 h-6 rounded bg-accent-500/30 flex-shrink-0"></div>
                        <div className="h-2 rounded bg-background-600 flex-1"></div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="flex justify-center mt-3">
                <div className="w-16 h-1 rounded-full bg-background-700"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}